import videojs from 'video.js';
import { VIDEO_JS_CONTROL_BAR_CONFIG } from './../core/config';
import './../assets/styles/video-js/video-js.min.css';

const VIDEO_AUTOPLAY_TIMEOUT = 100;
const CONTROLS_HIDE_TIMEOUT = 2000;
const VIDEO_RETRY_LIMIT = 3;
export const VIDEO_VJS_ASPECT_RATIO_FLUID = 'fluid';

export default {
  props: {
    src: { type: String, required: true },
    id: { type: String, required: true },

    controlBar: {
      default: () => VIDEO_JS_CONTROL_BAR_CONFIG // hero config overrides muteToggle
    },
    // TODO: I don't think 'lightbox' is going to do anything
    lightbox: { type: Boolean, default: false }, // lightbox mode , full player,
    aspectRatio: { type: String, default: '' },
    muted: { type: Boolean, default: false },
  },
  data() {
    return {
      player: '',
      playButton: null,
      pauseButton: null,
      timeouts: [],
      playerOptions: {},
    };
  },
  mounted() {
    this.initialize();
    this.playerSetupEvents();
  },
  beforeDestroy() {
    // dispose of player and clean up timeout.
    this.timeouts.forEach(timeout => clearTimeout(timeout));
    if (!this.player) return;
    this.player.dispose();
  },
  computed: {
    vjsSetup() {
      const options = {
        inactivityTimeout: 0,
      };

      if (this.aspectRatio) {
        options.aspectRatio = this.aspectRatio;
      }
      return options;
    },

    dataSetup() {
      return JSON.stringify(this.vjsSetup);
    }
  },
  watch: {
    src(value) {
      if (this.player) {
        // don't want errors because I'm to tired to deal with them
        this.player.src(value);
        this.playVideo();
      }
    }
  },
  methods: {
    checkPlayer() {
      if (!this.player) {
        throw new Error(`Player not initialized: ${this.id}`);
      }
    },

    /**
     * initialize the player
     */
    initialize() {
      if (!this.aspectRatio) {
        this.playerOptions.fluid = true;
      }
      this.playerOptions.controlBar = this.controlBar;
      this.player = videojs(this.$refs.video, this.playerOptions);
      this.checkPlayer();

      this.player.src(this.src);
    },
    /**
     * Handle a click on a play button
     */
    playClick() {
      this.handleClick();
    },
    /**
     * play the video
     */
    playVideo() {
      this.checkPlayer();
      this.player.play();
    },
    /**
     * set up various events on the player.
     */
    playerSetupEvents() {
      this.checkPlayer();

      this.player.on('error', (e) => {
        console.log(e);
      });
      this.player.on('ready', () => {
        this.autoPlay();
      });
      // may need back when we get ui for submission videos
      // this.player.on('play', () => {

      // });
      // this.player.on('pause', () => {
      //   this.playButton.removeClass('hidden');
      // });
    },
    /**
     * autoplay the video when it's ready.
     */
    autoPlay() {
      try {
        this.checkPlayer();
        this.timeouts.push(setTimeout(() => {
          // NOTE: this will break deep links if the video is ever not muted
          this.player.play();
        }, VIDEO_AUTOPLAY_TIMEOUT));
      } catch (error) {
        if (this.retry > VIDEO_RETRY_LIMIT) {
          throw new Error('Could not play video.');
        }
        window.clearTimeout(this.playTimeout);
        this.retry += 1;
      }
    },
    hideControlUi() {
      this.checkPlayer();
      this.timeouts.push(setTimeout(() => {
        if (!this.player.controlBar || !this.$refs.videoOverlay) return;
        this.player.controlBar.addClass('hidden');
        this.$refs.videoOverlay.classList.add('hidden');
      }, CONTROLS_HIDE_TIMEOUT));
    },
    showControlUi() {
      this.checkPlayer();
      if (!this.player.controlBar || !this.$refs.videoOverlay) return;
      this.player.controlBar.removeClass('hidden');
      this.$refs.videoOverlay.classList.remove('hidden');
    }
  },
};
